import { render } from "./Suspense.vue?vue&type=template&id=15980ba1"
import script from "./Suspense.vue?vue&type=script&lang=ts"
export * from "./Suspense.vue?vue&type=script&lang=ts"
script.render = render

export default script